import { render, staticRenderFns } from "./additional-traveler-bags.vue?vue&type=template&id=e3a58ff8&scoped=true"
import script from "./additional-traveler-bags.vue?vue&type=script&lang=js"
export * from "./additional-traveler-bags.vue?vue&type=script&lang=js"
import style0 from "./additional-traveler-bags.vue?vue&type=style&index=0&id=e3a58ff8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a58ff8",
  null
  
)

export default component.exports